import { render, staticRenderFns } from "./SampleEditableResultTable.vue?vue&type=template&id=1281f9dc"
import script from "./SampleEditableResultTable.vue?vue&type=script&lang=js"
export * from "./SampleEditableResultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports